module.exports = __webpack_public_path__ + "img/project-dependance_empty.fbf4d171.png";